var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "promotion_outline_24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Icon Color"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1001 19.0001C2.1001 18.503 2.50304 18.1001 3.0001 18.1001H21.0001C21.4972 18.1001 21.9001 18.503 21.9001 19.0001C21.9001 19.4972 21.4972 19.9001 21.0001 19.9001H3.0001C2.50304 19.9001 2.1001 19.4972 2.1001 19.0001Z",
    fill: "#AC92ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 5.9001C16.003 5.9001 15.6001 5.49715 15.6001 5.0001C15.6001 4.50304 16.003 4.1001 16.5001 4.1001H21.0001C21.4972 4.1001 21.9001 4.50304 21.9001 5.0001V9.5001C21.9001 9.99715 21.4972 10.4001 21.0001 10.4001C20.503 10.4001 20.1001 9.99715 20.1001 9.5001V7.17289L14.1365 13.1365C13.785 13.488 13.2152 13.488 12.8637 13.1365L9.5001 9.77289L3.63649 15.6365C3.28502 15.988 2.71517 15.988 2.3637 15.6365C2.01223 15.285 2.01223 14.7152 2.3637 14.3637L8.8637 7.8637C9.21517 7.51223 9.78502 7.51223 10.1365 7.8637L13.5001 11.2273L18.8273 5.9001H16.5001Z",
    fill: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.bc5a1e6b4dfff5a5e924e0a06190fb1e.svg";
export { ForwardRef as ReactComponent };